<template>
  <qx-card-form title="其他">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        inline: true,
        form: [
          {
            label: '备注说明',
            value: 'remarks',
            type: 'input',
            width: '400px',
            attr: {
              type: 'textarea',
            },
          },
        ],
        rules: {
          // remarks: [ // 备注说明
          //   { required: true, message: '请输入备注说明', trigger: 'blur' },
          // ],
        },
      },
    };
  },
  methods: {
    async cacheData () {
      const formData = await this.$refs.baseForm.getVal();
      return formData;
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      return formData;
    },
    init (data = {}) {
      const res = {
        remarks: data.remarks,
      };
      this.$refs.baseForm.setVal('form', res);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
